import React from 'react';
import { FormatOptionLabelMeta } from 'react-select';

import { useAddressOptions } from 'hooks/useAddressOptions';

type UseGroupOptionLabelArgs = {
  showAddress?: boolean;
  showGroupType?: boolean;
};

export default function useGroupOptionLabel(args?: UseGroupOptionLabelArgs) {
  const { showAddress = true, showGroupType = true } = args ?? {};

  const addressOptions = useAddressOptions();
  const addressProps = showAddress ? addressOptions : { formatOptionLabel: (o: any) => o?.name };

  const formatOptionLabelWithGroupType = (option: any, meta: FormatOptionLabelMeta<any>) => {
    const { name, groupType, ...rest } = option;

    const groupTypeDisplayName = groupType?.displayName;
    const groupTypeLabel = ` (${groupTypeDisplayName})`;

    const displayName = (
      <span>
        {name}
        {groupTypeDisplayName ? <em>{groupTypeLabel}</em> : ''}
      </span>
    );

    return addressProps.formatOptionLabel({ ...rest, name: displayName }, meta);
  };

  const formatOptionLabel = showGroupType ? formatOptionLabelWithGroupType : addressProps.formatOptionLabel;

  return {
    formatOptionLabel,
    getOptionLabel: (o: any) => o?.name ?? '',
    getOptionValue: (o: any) => o?.id ?? '',
  };
}
